'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _caseReference = require('./case-reference.html');

var _caseReference2 = _interopRequireDefault(_caseReference);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _caseReference2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    adverseEvent: '<',
    locked: '<'
  },
  controller: function CaseReferenceComponent(EventEmitter) {
    'ngInject';

    _classCallCheck(this, CaseReferenceComponent);

    Object.assign(this, { EventEmitter: EventEmitter });
    this.today = new Date();
  }
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/case-reference/case-reference.component.js